import { geocode as mapyGeocode, rgeocode as mapyRgeocode } from './mapyApi.service';

// Bounding box ČR pro omezení výsledků
const CZ_BOX = 'BOX(12.0921668,48.5370786,18.8927040,51.0746358)';

export const geolocationService = {
    findLocationByString,
    getLocationAsString,
    getLocationByGPS,
    distanceInKmBetweenEarthCoordinatesInKm,
    distanceInKmBetweenEarthCoordinatesInM
};

/**
 * Získá lokaci na základě zadaného textu (Mapy.cz REST API z prohlížeče).
 * @param {string} input – hledaný text
 * @param {function(Array)} callbackFn – volá se s polem výsledků, každý má např. coords: { y: lat, x: lon }
 * @param {string} [apiKey] – API klíč z konfigurace (CompanyConfiguration.MapyApiKey)
 */
function findLocationByString(input, callbackFn, apiKey) {

    if (!input || !input.trim()) {
        return;
    }
    if (!apiKey) {
        callbackFn([]);
        return;
    }

    mapyGeocode(input, apiKey, { limit: 10, locality: CZ_BOX })
        .then((data) => {
            if (data && data.length) callbackFn(data);
        })
        .catch(() => callbackFn([]));
}

// pokusí se získat lokaci na základě GPS ze zařízení
function getLocationByGPS(callbackFn) {

    if (!("geolocation" in navigator)) {
        thisHelper.errorStr = 'Geolokace není dostupná.';
        return;
    }

    let thisHelper = this;

    navigator.geolocation.getCurrentPosition(pos => {
        callbackFn(pos);
    }, err => {
        if (err.code == 1) {
            console.log("Uživatel nechce sdílet svoji lokaci.")
        }
        thisHelper.errorStr = err.message;
    })


}

/**
 * Získá adresu/místo na základě souřadnic (reverse geocoding, Mapy.cz REST API z prohlížeče).
 * @param {number} longitude
 * @param {number} latitude
 * @param {function(object)} callbackFn – volá se s objektem, např. { label, items } (první položka má .label)
 * @param {string} [apiKey] – API klíč z konfigurace
 */
function getLocationAsString(longitude, latitude, callbackFn, apiKey) {
    if (!apiKey) {
        callbackFn({});
        return;
    }
    mapyRgeocode(longitude, latitude, apiKey)
        .then((data) => {
            const items = data?.items || [];
            const first = items[0];
            callbackFn(first ? { label: first.label || first.name || first.location, items } : {});
        })
        .catch(() => callbackFn({}));
}

// převede stupně na radiány
function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}

// vypočítá vzdálenost mezi dvěmi souřadnicemi v km
function distanceInKmBetweenEarthCoordinatesInKm(lat1, lon1, lat2, lon2) {
    var earthRadiusKm = 6371;

    var dLat = degreesToRadians(lat2 - lat1);
    var dLon = degreesToRadians(lon2 - lon1);

    lat1 = degreesToRadians(lat1);
    lat2 = degreesToRadians(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadiusKm * c;
}

// vypoítá vzdálenost mezi dvěma souřadnicemi v m
function distanceInKmBetweenEarthCoordinatesInM(lat1, lon1, lat2, lon2) {
    return distanceInKmBetweenEarthCoordinatesInKm(lat1, lon1, lat2, lon2) * 1000.0;
}